import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import ObjectLogs from '../../misc/ObjectLogs';
import { GetObjectLogs } from '../../../store/ObjectLogAction';
import { CoreObjectLogs } from '../../../models/CoreObjectLogs';
import * as LogTypes from '../../../util/FlowSyncLoggerTypes';
import { useTranslation } from 'react-i18next';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';



const ActivityViewObjectLogs = () => {
    const { t } = useTranslation('schoolAdministration');

    const { activityId } = useParams();
    const dispatch = useDispatch();
    const objectLogs = useSelector<RootState, RequestState<CoreObjectLogs[]>>(state => state.objectLog.objectLogs);

    useEffect(() => {
        if (activityId) {
            GetObjectLogs({ objectId: activityId, objectSource: LogTypes.Flowsync.SourceName, objectType: LogTypes.Flowsync.Activity })(dispatch);
        }
    }, [dispatch, activityId]);

    return (<>
        <ObjectLogs
            objectLogs={objectLogs}
            noResMsg={t('noResult.activityObjectLogs', { ns: 'schoolAdministration' })}
        />
    </>);
}

export default ActivityViewObjectLogs;
